import React, { useEffect, useState } from "react";
import NotificationItem from "./NotificationItem";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import FeedNotification from "../Cards/FeedNotification";
import NotificationItem2 from "./NotificationItem2";

// Component to render notifications based on the user IDs in the notification.id array
export function GroupedNotification({ notification, user, feed }) {
  const [users, setUsers] = useState([]);

  // Fetch user data for each user ID in the notification.id array
  useEffect(() => {
    async function fetchUserData() {
      try {
        const userIds = notification?.id || []; // Reverse the IDs array // `notification.id` is an array of user IDs
        console.log(" user IDs:", userIds);
        // console.log("Reversed user IDs:", userIds.reverse());
        // Only fetch data if there are at least two user IDs
        if (userIds.length >= 2) {
          const userData = await Promise.all(
            userIds.slice(0, 2).map(async (userId) => {
              // Fetch data for the first and second user
              const userDoc = await getDoc(doc(db, "users", userId));
              if (userDoc.exists()) {
                return { userId, ...userDoc.data() }; // Return user data if found
              } else {
                console.error(`No such user with ID ${userId}`);
                return null;
              }
            })
          );
          setUsers(userData.filter((user) => user !== null)); // Filter out any null values from the array
        } else {
          setUsers([]); // Set to empty if there are less than 2 user IDs
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setUsers([]); // Set to empty in case of error
      }
    }

    fetchUserData();
  }, []);
  console.log("firstUserData fromg gN", users[0]);
  // Render notifications with fetched user data
  return (
    <>
      {users.length > 0 && (
        <NotificationItem2
          key={notification.type}
          message={generateMessage(users, notification)}
          route={getRouteForNotification(notification, user)}
          firstUserData={users[0]} // Pass the first user's data
          secondUserData={users[1]}
          notification={notification}
          group={true}
        />
      )}
    </>
  );
}

// Helper functions for message generation
function generateMessage(users, notification) {
  const userCount = notification.id.length;
  switch (notification.type) {
    case "followed":
      return generateFollowMessage(users, userCount);
    case "postLike":
      return generateLikeMessage(users, userCount);
    case "postComment":
      return generateCommentMessage(users, userCount);
    case "listProductLike":
      return generateListProductLikeMessage(users, userCount, notification);
    case "acceptFriendRequest":
      return generateAcceptFriendRequestMessage(users, userCount, notification);
    default:
      return "";
  }
}

const BoldText = ({ children }) => (
  <span
    style={{
      fontFamily: "Inter",
      color: "#000000",
      fontWeight: 500,
      fontSize: "15px",
    }}
  >
    {children}
  </span>
);

function generateFollowMessage(users, userCount) {
  if (userCount === 1) return <> started following you.</>;
  if (userCount === 2)
    return <> and {users[1]?.firstName} started following you.</>;
  if (userCount === 3)
    return (
      <>
        , <>{users[1]?.firstName}</> and <BoldText>1</BoldText> other started
        following you.
      </>
    );
  return (
    <>
      , <>{users[1]?.firstName}</>, and <BoldText>{userCount - 2}</BoldText>{" "}
      others started following you.
    </>
  );
}

function generateLikeMessage(users, userCount) {
  if (userCount === 1) return <> liked your post.</>;
  if (userCount === 2) return <> and {users[1]?.firstName} liked your post.</>;
  if (userCount === 3)
    return (
      <>
        , {users[1]?.firstName} and <BoldText>1</BoldText> other liked your
        post.
      </>
    );
  return (
    <>
      , <>{users[1]?.firstName}</>, and <BoldText>{userCount - 2}</BoldText>{" "}
      others liked your post.
    </>
  );
}

function generateCommentMessage(users, userCount) {
  if (userCount === 1) return <> commented on your post.</>;
  if (userCount === 2)
    return <> and {users[1]?.firstName} commented on your post.</>;
  if (userCount === 3)
    return (
      <>
        , <>{users[1]?.firstName}</> and <BoldText>1</BoldText> other commented
        on your post.
      </>
    );
  return (
    <>
      , <>{users[1]?.firstName}</>, and <BoldText>{userCount - 2}</BoldText>{" "}
      others commented on your post.
    </>
  );
}
function generateAcceptFriendRequestMessage(users, userCount) {
  if (userCount === 1) return <> accepted your friend request.</>;
  if (userCount === 2)
    return <> and {users[1]?.firstName} accepted your friend request.</>;
  if (userCount === 3)
    return (
      <>
        , {users[1]?.firstName} and <BoldText>1</BoldText> other accepted your
        friend request.
      </>
    );
  return (
    <>
      , <>{users[1]?.firstName}</>, and <BoldText>{userCount - 2}</BoldText>{" "}
      others accepted your friend request.
    </>
  );
}

function generateListProductLikeMessage(users, userCount, notification) {
  if (userCount === 1)
    return <> liked your product in {notification.shopList} list.</>;
  if (userCount === 2)
    return (
      <>
        {" "}
        and {users[1]?.firstName} liked your product in {notification.shopList}{" "}
        list.
      </>
    );
  if (userCount === 3)
    return (
      <>
        <>{users[1]?.firstName}</> and <BoldText>1</BoldText> other liked your
        product in {notification.shopList} list.
      </>
    );
  return (
    <>
      , <>{users[1]?.firstName}</>, and <BoldText>{userCount - 2}</BoldText>{" "}
      others liked your product in {notification.shopList} list.
    </>
  );
}

// Helper function to determine the route based on the notification type
function getRouteForNotification(notification, user) {
  switch (notification.type) {
    case "followed":
      return `/userProfile/${user.uid}/userfollowers`; // Redirect to the first user's profile
    case "postLike":
      return `/post/${notification.postId}`; // Redirect to the liked post
    case "postComment":
      return `/post/${notification.postId}`; // Redirect to the commented post
    case "acceptFriendRequest":
      return `/userProfile/${user.uid}/userConnections`; // Redirect to the commented post
    case "listProductLike":
      return `/shoppingList/${notification.listId}/${user.uid}`;
    default:
      return "/";
  }
}
